import {IActJson} from '../../../diagram-data/diagram-json-handler.service';

declare let mxConstants: any;
import * as util from '../styles.util';
import {InfoStyle, MxStyleObject, ResourceEntityStyle, ServerStyleObject} from '../styles.model';
import {StyleKeeper} from './style-keeper.model';
import {getActivityMinWH} from '../styles.util';
import {DiagramTypeConfigService} from '../../../core/services/diagram-type-config.service';

export class ActivityStyleKeeper implements StyleKeeper {
  private resourceCounter = 0;
  private height: number;
  public resourceStyle;

  constructor(
    private readonly activity: IActJson,
    private readonly styles: ServerStyleObject,
    private diagramTypeConfigService?: DiagramTypeConfigService,
    private readonly resStyle?: ServerStyleObject,
    private readonly infoStyle?: InfoStyle
  ) {
    if (this.activity && this.activity.position) {
      if (Array.isArray(this.activity.resources)) {
        this.resourceStyle = resStyle;
        this.resourceCounter = this.activity.resources.reduce(
          (acc, curr) => (curr.hidden || curr.main ? acc : ++acc),
          0
        );
      }

      this.height = this.activity.position.h;
    } else {
      this.height = 72;
    }
  }

  public original() {
    return this.styles;
  }

  public shape() {
    return {
      whiteSpace: 'wrap',
      hideNumber: this.styles.hideNumber
    };
  }

  public boundingBox() {
    return {
      borderWidth: this.styles.borderWidth + 'px',
      borderColor: this.styles.borderColor,
      borderRadius: Math.round(this.styles.arcSize) + 'px',
      borderStyle: this.styles.borderStyle || 'solid',
      boxShadow: this.styles.shadow ? '2px 2px 2px #888888' : 'none',
      backgroundColor: this.styles.backgroundColor
    };
  }

  public mxCellCss(opts?) {
    const {minWidth, minHeight} = getActivityMinWH(
      this.activity,
      this.diagramTypeConfigService.currentType()
    );
    const result = {
      arcSize: Math.round(this.styles.arcSize),
      rounded: this.styles.arcSize > 0 ? 1 : 0,
      html: 1,
      spacing: 0,
      rotatable: 0,
      clipped: 0,
      minWidth: minWidth,
      minHeight: minHeight,
      whiteSpace: 'wrap',
      fillColor: mxConstants.NONE,
      strokeWidth: 2,
      strokeColor: mxConstants.NONE,
      [mxConstants.STYLE_OVERFLOW]: 'fill',
      locked: +!!+this.activity.locked
    };

    return util.objectToString(result, '=');
  }

  public fontWrapper() {
    const calcHeight = this.height - 32 - this.resourceCounter * 24 - 3;

    return {
      maxHeight: calcHeight,
      height: calcHeight,
      display: 'block'
    };
  }

  public fontCss() {
    const result: MxStyleObject = {
      fontFamily: this.styles.font,
      color: this.styles.fontColor,
      fontSize: this.styles.fontSize,
      textAlign: this.styles.textAlign || 'center',
      borderBottomColor: this.styles.underlineColor || '#C9C9C9'
    };

    if (this.styles.fontBold) {
      result.fontWeight = 'bold';
    }

    if (this.styles.fontItalic) {
      result.fontStyle = 'italic';
    }

    if (this.styles.fontUnderline) {
      result.textDecoration = 'underline';
    }

    return result;
  }

  public colors() {
    return {
      iconColor: this.styles.iconColor,
      numberColor: this.styles.numberColor,
      numberIconcolor: this.styles.numberIconColor,
      borderColor: this.styles.borderColor
    };
  }

  public fillColor() {
    return {background: this.styles.backgroundColor};
  }

  public getResourceStyle() {
    if (!this.resourceStyle) {
      return;
    }

    return {
      facility: this.getResourceEntityStyle(this.resourceStyle.facility),
      human: this.getResourceEntityStyle(this.resourceStyle.human),
      system: this.getResourceEntityStyle(this.resourceStyle.system),
      platform: this.getResourceEntityStyle(this.resourceStyle.platform),
      industry: this.getResourceEntityStyle(this.resourceStyle.industry),
      flow: this.getResourceEntityStyle(this.resourceStyle.flow),
      object: this.getResourceEntityStyle(this.resourceStyle.object)
    };
  }

  public getInfoStyle() {
    if (!this.infoStyle) {
      return;
    }

    return {
      backgroundColor: this.infoStyle.backgroundColor,
      icon: this.infoStyle.icon,
      iconColor: this.infoStyle.iconColor,
      squared: this.infoStyle.squared
    };
  }

  private getResourceEntityStyle(entityStyle): ResourceEntityStyle {
    if (!entityStyle) {
      return null;
    }

    const result = {
      fontFamily: entityStyle.font,
      color: entityStyle.fontColor
    };

    if (entityStyle.fontBold) {
      result['fontWeight'] = 'bold';
    }

    if (entityStyle.fontItalic) {
      result['fontStyle'] = 'italic';
    }

    if (entityStyle.fontUnderline) {
      result['textDecoration'] = 'underline';
    }

    return result;
  }
}
